import { Injectable } from '@angular/core';
import { environment } from '../environments/environment';

@Injectable({ providedIn: 'root' })
export class AssetsService {
  private readonly cdnImgBaseUrl = environment.cdnImgBaseUrl;

  getUrl(path: string): string {
    // Si es de img/ -> usa el CDN
    if (path.startsWith('img/')) {
      return `${this.cdnImgBaseUrl}${path.replace(/^img\//, '')}`;
    }
    // Resto de assets locales
    return `assets/${path}`;
  }
}
